module.exports = __webpack_public_path__ + "img/icon_futi_02.1810ac65.png";